module.exports = __webpack_public_path__ + "img/title.4c0467fa.webp";